// constants.ts

export const NAME = 'importPatients';